import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://www.mobbing-melden.de';
const DEFAULT_IMAGE = BASE_URL + '/og-image.png';

export default function SEO({ title, description, path = '/', schema = null }) {
  const fullTitle = title
    ? title + ' | mobbing-melden.de'
    : 'Mobbing melden – Sichere & anonyme Hilfe fuer Kinder | mobbing-melden.de';
  const url = BASE_URL + path;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content="mobbing-melden.de" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
